module.exports = __webpack_public_path__ + "static/media/DSCF6066.38f06b53.jpg";